import React from "react";
import {Navigate, Outlet, useLocation} from "react-router";
import useAuthState from "@/context/authentication/use-auth-state";
import AuthProvider from "@/context/authentication/auth-provider";
import router from "@/routing/Router";
import RestaurantProvider from "@/context/restaurant/RestaurantProvider";

const AuthenticatedLayout = () => {
    const {user} = useAuthState();
    const location = useLocation();


    if (user === null) {
        return (
            <Navigate
                to={router.signIn.absolutePath()}
                state={{
                    from: location,
                }}
                replace
            />
        );
    }

    return (
        <AuthProvider user={user}>
            <RestaurantProvider>
                <Outlet/>
            </RestaurantProvider>
        </AuthProvider>
    );
};

export default AuthenticatedLayout;